import React from "react";
import { Row, Col, Container } from "react-bootstrap";
import WpImage from "../components/WpImage";
import ContainerWide from "../components/ContainerWide";

const KeyBenefits = ({
    category,
    header,
    description,
    benefits,
    className,
    slug,
}) => {
    if (!benefits || benefits.length === 0) return null;

    return (
        <Container
            className={`key-benefits ${className || ""}`}
            id={slug || "key-benefits"}
        >
            {(category || header) && (
                <Row className="key-benefits__header-row">
                    <Col>
                        {category && (
                            <p
                                className="key-benefits__label"
                                dangerouslySetInnerHTML={{ __html: category }}
                            />
                        )}
                        {header && (
                            <h2
                                className="key-benefits__header"
                                dangerouslySetInnerHTML={{ __html: header }}
                            />
                        )}
                    </Col>
                </Row>
            )}
            {description && (
                <Row className="key-benefits__description-row">
                    <Col>
                        <p
                            className="key-benefits__description"
                            dangerouslySetInnerHTML={{ __html: description }}
                        />
                    </Col>
                </Row>
            )}
            {benefits.map((benefit, index) => (
                <Row key={index} className="key-benefits__row">
                    <Col lg={9} xs={24} className="key-benefits__left-col">
                        <div className="key-benefits__left-wrapper">
                            {benefit.icon && (
                                <WpImage
                                    image={benefit.icon}
                                    alt={benefit.title || ""}
                                    className="key-benefits__icon"
                                />
                            )}
                            {benefit.title && (
                                <h3
                                    className="key-benefits__title"
                                    dangerouslySetInnerHTML={{
                                        __html: benefit.title,
                                    }}
                                />
                            )}
                        </div>
                    </Col>
                    <Col lg={13} className="key-benefits__desc-col offset-lg-2">
                        {benefit.description && (
                            <div
                                className="key-benefits__description"
                                dangerouslySetInnerHTML={{
                                    __html: benefit.description,
                                }}
                            />
                        )}
                    </Col>
                </Row>
            ))}
        </Container>
    );
};

export default KeyBenefits;
